import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'VRMA No',
     label: 'VRMA No',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'statusName',
     field: FIELDS.STATUS_NAME,
     title: 'Status',
     label: 'Status',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'rmaDate',
     field: FIELDS.RMADATE,
     title: 'VRMA Date',
     label: 'VRMA Date',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'poDate',
     field: FIELDS.PODATE,
     title: 'PO Date',
     label: 'PO Date',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'companyName',
     field: FIELDS.COMPANY_NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactName',
     field: FIELDS.CONTACT_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactEmail',
     field: FIELDS.CONTACT_EMAIL,
     title: 'Contact Email',
     label: 'Contact Email',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'dateShipped',
     field: FIELDS.DATE_SHIPPED,
     title: 'Date Shipped',
     label: 'Date Shipped',
     cell: 'formatDate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'actionName',
     field: FIELDS.ACTION_NAME,
     title: 'Action',
     label: 'Action',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'termsName',
     field: FIELDS.TERMS_NAME,
     title: 'Disposition',
     label: 'Disposition',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'salesPersonUserFullName',
     field: FIELDS.SALES_PERSON_USER_FULL_NAME,
     title: 'Sales Person',
     label: 'Sales Person',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isAuthorized',
     field: FIELDS.IS_AUTHORIZED,
     title: 'Authorized',
     label: 'Authorized',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'subTotal',
     field: FIELDS.SUB_TOTAL,
     title: 'Sub Total',
     label: 'Sub Total',
     cell: 'formatCurrency',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalLineCost',
     field: FIELDS.TOTAL_LINE_COST,
     title: 'Total Line Cost',
     label: 'Total Line Cost',
     cell: 'formatCurrency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxable',
     field: FIELDS.TOTAL_CHARGES_TAXABLE,
     title: 'Total Charges Taxable',
     label: 'Total Charges Taxable',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxable',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE,
     title: 'Total Charges Non Taxable',
     label: 'Total Charges Non Taxable',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalCharges',
     field: FIELDS.TOTAL_CHARGES,
     title: 'Total Charges',
     label: 'Total Charges',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'totalChargesCost',
     field: FIELDS.TOTAL_CHARGES_COST,
     title: 'Total Charges Cost',
     label: 'Total Charges Cost',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'total',
     field: FIELDS.TOTAL,
     title: 'Total',
     label: 'Total',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'comments',
     field: FIELDS.COMMENTS,
     title: 'Comments',
     label: 'Comments',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shipFromAddress',
     field: FIELDS.SHIP_FROM_ADDRESS,
     title: 'Ship From',
     label: 'Ship From',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shipToAddress',
     field: FIELDS.SHIP_TO_ADDRESS,
     title: 'Ship To',
     label: 'Ship To',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'internalComments',
     field: FIELDS.INTERNAL_COMMENTS,
     title: 'Internal Comments',
     label: 'Internal Comments',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shippingProviderName',
     field: FIELDS.SHIPPING_PROVIDER_NAME,
     title: 'Ship Via',
     label: 'Ship Via',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'shippingMethodName',
     field: FIELDS.SHIPPING_METHOD_NAME,
     title: 'Ship Method',
     label: 'Ship Method',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'isTaxable',
     field: FIELDS.IS_TAXABLE,
     title: 'Taxable',
     label: 'Taxable',
     cell: 'checkMark',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'currencyTypeName',
     field: FIELDS.CURRENCY_TYPE_NAME,
     title: 'Currency',
     label: 'Currency',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'exchangeRate',
     field: FIELDS.EXCHANGE_RATE,
     title: 'Exch Rate',
     label: 'Exch Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'taxRate',
     field: FIELDS.TAX_RATE,
     title: 'Tax Rate',
     label: 'Tax Rate',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'tax',
     field: FIELDS.TAX,
     title: 'Tax',
     label: 'Tax',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'subTotalConverted',
     field: FIELDS.SUB_TOTAL_CONVERTED,
     title: 'Sub Total Conv',
     label: 'Sub Total Conv',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalLineCostConverted',
     field: FIELDS.TOTAL_LINE_COST_CONVERTED,
     title: 'Total Line Cost Conv',
     label: 'Total Line Cost Conv',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_TAXABLE_CONVERTED,
     title: 'Total Charges Taxable Conv',
     label: 'Total Charges Taxable Conv',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesNonTaxableConverted',
     field: FIELDS.TOTAL_CHARGES_NON_TAXABLE_CONVERTED,
     title: 'Total Charges Non Taxable Conv',
     label: 'Total Charges Non Taxable Conv',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesConverted',
     field: FIELDS.TOTAL_CHARGES_CONVERTED,
     title: 'Total Charges Conv',
     label: 'Total Charges Conv',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalChargesCostConverted',
     field: FIELDS.TOTAL_CHARGES_COST_CONVERTED,
     title: 'Total Charges Cost Conv',
     label: 'Total Charges Cost Conv',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'totalConverted',
     field: FIELDS.TOTAL_CONVERTED,
     title: 'Total Converted',
     label: 'Total Converted',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'shipOnVendorAccount',
     field: FIELDS.SHIP_ON_VENDOR_ACCOUNT,
     title: 'Ship On Vendor Account',
     label: 'Ship On Vendor Account',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'alwaysShipBy',
     field: FIELDS.ALWAYS_SHIP_BY,
     title: 'Always Ship By',
     label: 'Always Ship By',
     sortable: true,
     hidden: true,
     width: 75,
  },{
     key: 'shippingAccountNumber',
     field: FIELDS.SHIPPING_ACCOUNT_NUMBER,
     title: 'Shipping Account Number',
     label: 'Shipping Account Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'trackingNumber',
     field: FIELDS.TRACKING_NUMBER,
     title: 'Tracking Number',
     label: 'Tracking Number',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'authorizedByUserFullName',
     field: FIELDS.AUTHORIZED_BY_USER_FULL_NAME,
     title: 'Authorized By',
     label: 'Authorized By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateAuthorized',
     field: FIELDS.DATE_AUTHORIZED,
     title: 'Date Auth',
     label: 'Date Auth',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUser',
     field: FIELDS.CREATED_BY_USER,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUser',
     field: FIELDS.MODIFIED_BY_USER,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
